export default {
  title: 'Ta restauracja nie może jeszcze zostać uruchomiona',
  description:
    'Twoje konto partnera nie ma ustawionej prowizji za przetwarzanie płatności online i nie potwierdziło 0% marży. Stripe pobiera swoje prowizje od Twojej platformy, więc najpierw trzeba zdecydować o jednym z tych dwóch rozwiązań.',
  partner_action:
    'Ustaw domyślną prowizję za przetwarzanie lub potwierdź, że nie pobierasz jej od swoich restauracji i sam pokrywasz prowizje Stripe.',
  ask_partner:
    'Twój partner nie ustawił jeszcze opłaty za przetwarzanie płatności online. Ta restauracja będzie mogła ruszyć, gdy to zrobi.',
  buttons: {
    set_rate: 'Ustaw prowizję za przetwarzanie',
    close: 'Zamknij',
  },
};
